import '../Home/Home.css';

import {
  useEffect,
  useState,
} from 'react';

import moment from 'moment/moment';

import DPimg1 from '../../assets/DP/img1.jpg';
import Cover1 from '../../assets/Friends-Cover/cover-1.jpg';
import img1 from '../../assets/Post Images/img1.jpg';
import Profile from '../../assets/profile.jpg';
import Left from '../../components/LeftSide/Left';
import Middle from '../../components/MiddleSide/Middle';
import Right from '../../components/RightSide/Right';
import Nav from '../../components/SecureNav/Nav';
import { get } from '../../service/apiService';

const Home = ({ setFriendsProfile }) => {

  const userData = JSON.parse(localStorage.getItem('userData')) || {}
  const member_id=userData.user_profile?.member_id || ''

  const [posts1, setPosts1] = useState(
    [
      {
        id: 1,
        username: "Harry",
        profilepicture: DPimg1,
        img: img1,
        datetime: moment("20230131", "YYYYMMDD").fromNow(),
        body: "My 1st Post, Have A Good Day Lorem ipsum dolor sit, amet consectetur adipisicing elit. Porro ipsum laborum necessitatibus ex doloragnam ea?",
        like: 44,
        comment: 3,
        unFilledLike: true,
        coverpicture: Cover1,
        userid: "@Iamharry",
        ModelCountryName: "USA",
        ModelJobName: "Java Developer",
        ModelJoinedDate: "Joined in 2019-02-28",
        followers: 1478
      }
    ]
  )


  const [posts, setPosts] = useState([]);


  useEffect(() => {
    const fetchPosts = async () => {
      console.log("fetchPosts");
      try {
        const response = await get("api/v1/member-stories/3ca4a8a1-aadb-4312-8a75-d54d65a12dc7");
        console.log("DATA", response.data);
        setPosts(response.data)
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };

    fetchPosts();
  }, []);


  const [body, setBody] = useState("")
  const [importFile, setImportFile] = useState("")


  const handleSubmit = (e) => {
    e.preventDefault()


    const id = posts.length ? posts[posts.length - 1].id + 1 : 1
    const username = "Vijay"
    const profilepicture = Profile
    const datetime = moment.utc(new Date(), 'yyyy/MM/dd kk:mm:ss').local().startOf('seconds').fromNow()
    const img = images ? { img: URL.createObjectURL(images) } : null

    const obj = {
      id: id,
      profilepicture: profilepicture,
      username: username,
      datetime: datetime,
      img: img && (img.img),
      body: body,
      like: 0,
      comment: 0
    }



    const insert = [...posts, obj]
    setPosts(insert)
    setBody("")
    setImages(null)

  }

  const [search, setSearch] = useState("")


  const [following, setFollowing] = useState("")

  const [showMenu, setShowMenu] = useState(false)
  const [images, setImages] = useState(null)

  return (
    <div className='interface'>
      <Nav
        search={search}
        setSearch={setSearch}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
      />

      <div className="home">

        <Left 
        member_id={member_id}
        />

        <Middle
          handleSubmit={handleSubmit}
          body={body}
          setBody={setBody}
          importFile={importFile}
          setImportFile={setImportFile}
          posts={posts}
          setPosts={setPosts}
          search={search}
          setFriendsProfile={setFriendsProfile}
          images={images}
          setImages={setImages}

        />

        <Right
          showMenu={showMenu}
          setShowMenu={setShowMenu}
          following={following}
          setFollowing={setFollowing}
        />
      </div>

    </div>
  )
}

export default Home